import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SmaMonitoringPlansContainer, SmaCampaignsContainer, SmaMonitoringPlansComparisonContainer, ImportContainer,
  SmaIssuesContainer, LandContainer, BiodiversityContainer, ProjectOverviewContainer, InterestAreasContainer, MonitoringPlanContainer,
  PressuresContainer, DependenciesContainer, ProjectPressuresAndDependenciesContainer, IsicContainer, SitesContainer,
  FreshwaterContainer, PhysicalAccountingContainer, SitesOverviewContainer, ProgressStatusContainer } from 'src/scenes/Project';


const routes = [
  {
    path: 'overview',
    Component: ProjectOverviewContainer,
  },
  {
    path: 'land',
    Component: LandContainer,
  },
  {
    path: 'biodiversity',
    Component: BiodiversityContainer,
  },
  {
    path: 'ocean',
    Component: () => <>Hola oceano</>,
  },
  {
    path: 'freshwater',
    Component: FreshwaterContainer,
  },
  {
    id: 'pressures-and-dependencies',
    path: 'pressures-and-dependencies',
    Component: ProjectPressuresAndDependenciesContainer,
  },
  {
    id: 'pressures',
    path: 'pressures',
    Component: PressuresContainer,
  },
  {
    id: 'dependencies',
    path: 'dependencies',
    Component: DependenciesContainer,
  },
  {
    path: 'interest-areas',
    Component: InterestAreasContainer,
  },
  {
    path: 'isic',
    Component: IsicContainer,
  },
  {
    path: 'campaigns',
    Component: SmaCampaignsContainer,
  },
  {
    path: 'monitoring-plans',
    Component: SmaMonitoringPlansContainer,
  },
  {
    path: 'sites',
    Component: SitesContainer,
  },
  {
    path: 'sites-overview',
    Component: SitesOverviewContainer,
  },
  {
    path: 'monitoring-plans/comparison',
    Component: SmaMonitoringPlansComparisonContainer,
  },
  {
    path: 'monitoring-plans/:monitoringPlanId',
    Component: MonitoringPlanContainer,
    hasNestedRoutes: true,
  },
  {
    path: 'compromises',
    Component: () => <>Hola compromisos</>,
  },
  {
    path: 'rca',
    Component: () => <>Hola rcas</>,
  },
  {
    path: 'physical-accounting',
    Component: PhysicalAccountingContainer,
  },
  {
    path: 'progress-status',
    Component: ProgressStatusContainer,
  },
  {
    path: 'import/sma',
    Component: ImportContainer,
    allowOnly: [ 'admin' ],
  },
  {
    path: 'import/capture',
    Component: ImportContainer,
    allowOnly: [ 'admin' ],
  },
  {
    path: 'import',
    Component: ImportContainer,
  },
  {
    path: 'issues',
    Component: SmaIssuesContainer,
  },
];


const ProjectRoutes = props => {
  const match = useRouteMatch();
  const { path: basePath, url: routeUrl } = match;
  const redirectToProjectMainPage = () => <Redirect to={`${routeUrl}/overview`} />;

  const filteredRoutes = routes.filter(({ allowOnly }) => !allowOnly || allowOnly.includes(props.userRoleId));

  return (
    <Switch>
      {filteredRoutes.map(({ path, Component, hasNestedRoutes }, index) =>
        <Route
          key={index}
          exact={!hasNestedRoutes}
          path={`${basePath}/${path}`}
          render={rProps => <Component {...rProps} {...props} />}
        />,
      )}
      <Route path={basePath} component={redirectToProjectMainPage} />
    </Switch>
  );
};

ProjectRoutes.propTypes = {
  userRoleId: PropTypes.oneOf([ 'admin', 'user', 'consultant' ]),
};


export { ProjectRoutes };
